__turbopack_context__.v({
  "actions": "HomeHero-module__NRzLjq__actions",
  "banner": "HomeHero-module__NRzLjq__banner",
  "crisis-pulse": "HomeHero-module__NRzLjq__crisis-pulse",
  "crisisCta": "HomeHero-module__NRzLjq__crisisCta",
  "crisisDot": "HomeHero-module__NRzLjq__crisisDot",
  "cta": "HomeHero-module__NRzLjq__cta",
  "hero": "HomeHero-module__NRzLjq__hero",
  "inner": "HomeHero-module__NRzLjq__inner",
  "lead": "HomeHero-module__NRzLjq__lead",
  "tag": "HomeHero-module__NRzLjq__tag",
  "tagRule": "HomeHero-module__NRzLjq__tagRule",
  "tagText": "HomeHero-module__NRzLjq__tagText",
  "title": "HomeHero-module__NRzLjq__title",
});
